<template>
  <table class="table no-border table-product-list bg">
    <thead>
    <tr>
      <td>物流中心</td>
      <td>合格业务库存</td>
      <td>不合格业务库存</td>
      <td>业务停销</td>
      <td>合格实物库存</td>
      <td>不合格实物库存</td>
      <td>在途库存</td>
      <td style="width: 80px">单价</td>
      <td>创建时间</td>
    </tr>
    </thead>
    <tbody>
    <tr v-for="item in data" :key="item.id">
      <td>
        {{item.logisticsCentreName}}
      </td>
      <td>
        {{item.availableCount}}
      </td>
      <td>
        {{item.unqualifiedBizCount}}
      </td>
      <td>
        {{item.undeterminedCount}}
      </td>
      <td>
        {{item.qualifiedCount}}
      </td>
      <td>
        {{item.unqualifiedCount}}
      </td>
      <td>
        {{item.transitCount}}
      </td>
      <td>
        ¥ {{item.unitPrice | formatMoney}}
      </td>
      <td>
        {{item.createTime | time}}
      </td>
    </tr>
    </tbody>
  </table>
</template>
<script>
  export default {
    props: {
      data: {
        type: Array,
        require: true
      }
    }
  }
</script>
